module.exports = __webpack_public_path__ + "img/lactalis.e8916154.png";